import type { FormEvent } from 'react'
import { FormControl } from 'baseui/form-control'
import { Textarea } from 'baseui/textarea'
import useOptInSmsTextField from './useOptInSmsTextField'

interface OptInSmsTextFieldProps {
  hidden?: boolean
  value: string
  onChange: (event: FormEvent<HTMLTextAreaElement>) => void
}

const OptInSmsTextField = ({ hidden = false, value, onChange }: OptInSmsTextFieldProps) => {
  const { label, caption, placeholder } = useOptInSmsTextField(value)

  if (hidden) return null

  return (
    <FormControl label={label} caption={caption}>
      <Textarea id='opt-in-sms-text-input' value={value} onChange={onChange} placeholder={placeholder} rows={5} />
    </FormControl>
  )
}

export default OptInSmsTextField
